import { render, staticRenderFns } from "./PassengerTypes.vue?vue&type=template&id=b773222c&scoped=true"
import script from "./PassengerTypes.vue?vue&type=script&lang=js"
export * from "./PassengerTypes.vue?vue&type=script&lang=js"
import style0 from "./PassengerTypes.vue?vue&type=style&index=0&id=b773222c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b773222c",
  null
  
)

export default component.exports